"use strict";

exports.__esModule = true;
exports.getAlphaBasedOnSelectionContext = getAlphaBasedOnSelectionContext;
var has = require("ramda").has;
var eqProps = require("ramda").eqProps;
function getAlphaBasedOnSelectionContext(props) {
  var dataRange = props.dataRange,
    selectionContext = props.selectionContext,
    valueKey = props.valueKey;

  // If chart does not respect selection context, or if selection context is not set
  // -> alpha should not be updated
  if (dataRange !== "SELECTION" || !selectionContext) {
    return function () {
      return 1;
    };
  }
  var selectorPath = selectionContext.selectorPath,
    selection = selectionContext.selected;
  if (!selectorPath || !selection) {
    return function () {
      return 1;
    };
  }
  return function (item) {
    var alpha = 1;
    if (!item[valueKey]) {
      console.error("Key " + valueKey + " is missing in item");
      return alpha;
    }
    var itemValues = item[valueKey];
    var itemNotInSelectionContext = Object.keys(itemValues).filter(function (key) {
      return has(key, selection);
    }).some(function (key) {
      return !eqProps(key, itemValues, selection);
    });
    if (itemNotInSelectionContext) {
      alpha = 0.3;
    }
    return alpha;
  };
}